export default __webpack_public_path__ + "static/media/ic-favicon.ad232883.svg";